import { render, staticRenderFns } from "./box3.vue?vue&type=template&id=6e8ce7b8&scoped=true&"
import script from "./box3.vue?vue&type=script&lang=js&"
export * from "./box3.vue?vue&type=script&lang=js&"
import style0 from "./box3.vue?vue&type=style&index=0&id=6e8ce7b8&lang=less&scoped=true&"
import style1 from "./box3.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8ce7b8",
  null
  
)

export default component.exports